import { useCallback, useEffect, useRef, useState } from "react";
import { getCapacity } from "../../data/marketsClient.js";
import { subscribePlanInvalidation, unsubscribePlanInvalidation } from "../../services/cacheBus.js";

// One request owner for the Markets list and its drawer. Hide previous values
// during refresh/failure, and ignore responses superseded by a newer read.
export function useCapacitySnapshot(enabled) {
  const [snapshot, setSnapshot] = useState({ status: "idle" });
  const sequence = useRef(0);
  const reload = useCallback(() => {
    const request = ++sequence.current;
    setSnapshot({ status: "loading" });
    return Promise.resolve().then(() => getCapacity()).then((data) => {
      if (!Array.isArray(data?.months) || !data.months.length || !Array.isArray(data?.markets)) {
        throw new Error("Capacity response was incomplete.");
      }
      if (request === sequence.current) setSnapshot({ status: "ok", data });
    }).catch((error) => {
      if (request === sequence.current) setSnapshot({ status: "error", error: error?.message || "Failed to load capacity." });
    });
  }, []);
  useEffect(() => {
    if (!enabled) return;
    reload();
    subscribePlanInvalidation(reload);
    window.addEventListener("focus", reload);
    const timer = window.setInterval(reload, 60000);
    return () => {
      ++sequence.current;
      unsubscribePlanInvalidation(reload);
      window.removeEventListener("focus", reload);
      window.clearInterval(timer);
    };
  }, [enabled, reload]);
  return [snapshot, reload];
}
